import { FC, useContext } from 'react'
import { ToolbarButton } from './ToolbarButton'
import { CutterContext } from '../contexts/CutterContext'
import { useHotkey } from '../../hooks/useHotkey'
import SvgRedo from '../../components/icons/Redo'
import { AppContext } from '../../AppContext'
import { isControlHotkey } from '../../functions/isControlHotkey'
import { getControlPlatformHotkey } from '../../functions/getControlPlatformHotkey'
import { logger } from '../../logger/logger'
import { LogActionType } from 'api/logs/log-action-type'
import { CutterActionType } from '../enums/CutterActionType'

export const ToolbarRedo: FC = () => {
  const { hotkeysEnabled } = useContext(AppContext)
  const { redo, redoAvailable } = useContext(CutterContext)

  useHotkey(
    (event) => (event.shiftKey && isControlHotkey(event, 90, 'z')) || isControlHotkey(event, 89, 'y'),
    () => {
      logger.log(LogActionType.HotkeyPress, { type: CutterActionType.Redo })

      redo()
    },
    hotkeysEnabled,
  )

  return (
    <ToolbarButton
      icon={<SvgRedo />}
      hotkey={getControlPlatformHotkey('+Y')}
      disabled={!redoAvailable}
      onClick={() => {
        logger.log(LogActionType.ToolbarButtonClick, { type: CutterActionType.Redo })

        redo()
      }}
    >
      Redo
    </ToolbarButton>
  )
}
